<template>
    <div class="itemsBlock">
        
        <button @click="addUser" class="btn btn-primary">+ ADD USER</button>
        
        <table class="table fz13">
            <tr class="fz13">
                <th>                    
                    <span>Name/Login</span>
                </th>
                <th>                    
                    <span>Change password</span>
                </th>
                <th>                    
                    <span>Delete user</span>
                </th>                
            </tr>            
            <UserCardList
                :key="`curUser_${curUser.id}`" 
                :user = curUser
                :isAdmin = 1
            />
            <UserCardList
                v-for="user in users" :key="`user_${user.id}`"
                :user = user
                :isAdmin = 0
            />
            <tr class="black_line">
                <td>

                </td>
                <td>

                </td>                
                <td>
                    <button @click="saveItems" class="btn btn-border-light">SAVE</button>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import {bus} from '../bus';
import axios from 'axios';

import Dotscontrol from './Dotscontrol';
import iconsort from "./iconsort";
import hrdate from "./hrdate";
import UserCardList from "./Users/UserCardList";
import Vue from 'vue';
// vue-no-autocomplete unpublished on npm — disable plugin (imports commented).
// import DisableAutocomplete from 'vue-disable-autocomplete';
// import NoAutoComplete from 'vue-no-autocomplete';
// Vue.use(DisableAutocomplete);
// Vue.use(NoAutoComplete);

export default {
    data(){
        return{            
            model_all: false,
            listdelete: [],
            btn_delete_all: true,
            model_find: '',
            users: [],
            curUser: ''
        }
    },
    methods: {
       addUser(){
            bus.$emit('openpopup', {
                'open': true,
                'type': 'user',
                'crud': 'create',
            })
        },
       saveItems(){           
           bus.$emit('updateUser');
       },       
       getCurUser() {            
            const url = `/getCurrentUser`;
            const params = {};
            axios.get(
                url,
                {
                    params: params,
                    headers: {
                        'ContentType': 'application/json'
                    }
                }
            ).then((response) => {
                this.data = response.data;
                this.curUser = response.data;
                console.log('this.curUser: ', this.curUser);
            }).catch( (error) => {
                // handle error
                console.log(error);
            });
        },
        getUsers() {            
            const url = `/users/`;
            const params = {};
            axios.get(
                url,
                {
                    params: params,
                    headers: {
                        'ContentType': 'application/json'
                    }
                }
            ).then((response) => {
                this.data = response.data;
                this.users = response.data;
            }).catch( (error) => {
                // handle error
                console.log(error);
            });
        }
    },
    watch: {},
    mounted(){
        this.getUsers();
        this.getCurUser();
        bus.$on('userAdded', ()=>{           
            this.getCurUser();
            this.getUsers();            
        });
        bus.$on('userDeleted', ()=>{
            console.log('user deleted fire!');
            this.getCurUser();
            this.getUsers();
        });
    },
    computed: {},
    components: {        
        iconsort,
        hrdate,
        UserCardList
    }
}
</script>

<style lang="scss">
    .itemsBlock {
        max-width: 800px;
        // background-color: #000A10;
        padding: 20px;
        font-size: 17px;
        border-radius: 0 0 3px 3px;
        overflow: hidden;
        .table {
            color: #E0E0E0;
            margin-top: 40px;
            // border: 20px solid #000A10;
            // border-top: none;
        }
        tr.black_line {
            border-top: none;
            border-bottom: none;
            border-right: 20px solid #000A10;
            border-left: 20px solid #000A10;            
        }
        tr.black_line:last-child {
            border-radius: 5px;
        }
        tr.black_line:last-child td {
            border-bottom: none;            
        }
        .table td {
            padding-top: 20px;
            padding-bottom: 20px;
            border-bottom: 1px solid rgba($color: #fff, $alpha: 0.2);
        }
        table .btn {            
            padding: 0.375rem 2.75rem;
            font-weight: 600;
            color: #ffffff9e;
        }
    }
        
</style>
